<template>
  <div>
    <input
      id="form__magazine"
      v-model="complianceMagazine"
      class="form-check-input"
      name="magazine"
      type="checkbox">
    <i18n
      path="globals.checkboxes.complianceMagazine.text"
      tag="label"
      class="form-check-label"
      for="form__magazine">
      <template v-slot:link>
        <a
          v-tooltip="$t('globals.privacyPolicyMarketing')"
          :href="linkHref"
          class="link link-underlined"
          target="_blank"
          @click="onClick(e)"
        >{{ $t('globals.checkboxes.complianceMagazine.linkText') }}</a>
      </template>
    </i18n>
    <TextPageModal
      v-if="showModal"
      ref="modalPrivacyPolicyMarketing"
      :text-page-slug="linkSlug"
    />
  </div>
</template>

<script>
import TextPageModal from '@theme/components/utils/TextPageModal'

export default {
  components: {
    TextPageModal,
  },
  data() {
    return {
      linkSlug: this.$t('globals.pageSlugs.privacyPolicyMarketing'),
    }
  },
  computed: {
    complianceMagazine: {
      get() {
        return this.$store.state.cart.input.complianceMagazine
      },
      set(value) {
        this.$store.commit('cart/SET_CART_INPUT_FIELD', { field: 'complianceMagazine', value: value })
      },
    },
    linkHref() {
      return this.localePath({ name: 'page-slug', params: { slug: this.linkSlug } })
    },
    showModal() {
      return this.$themeSettings.components.PageCheckoutInfo.openTextPageLinksInModal
    },
  },
  methods: {
    onClick() {
      if (this.$themeSettings.components.PageCheckoutInfo.openTextPageLinksInModal) {
        e.preventDefault()
        e.stopPropagation()
        this.$refs.modalPrivacyPolicyMarketing.show()
        return false
      }
      return true
    },
  },
}
</script>
